import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectPartida } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const SocioFormGroup = ({ iError, iTouched, fIsSubmitting, vSocio }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('inputselect-glosa', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='PRTDA' htmlFor='select-partida' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='_idPartida'>
          {({ field }) => (
            <SelectPartida
              {...field}
              showNewButton
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-partida'
              idSocio={vSocio}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SocioFormGroup)
